import {AppContext} from 'components/AppContext'
import {
    EmbedContext,
} from 'components/EmbedContext'
import {NinchatAttributes} from 'api/types'
import React from 'react'

export type UseLightboxReturn = {
    isOpen: boolean
    src: string | null
    fileAttrs: NinchatAttributes.NinchatFileAttributes | null
    open: (src: string, attrs: NinchatAttributes.NinchatFileAttributes | null, options?: {
        downloadDisabled?: boolean
    }) => void
    close: () => void
    options: {
        downloadDisabled?: boolean
    }
}

const useLightbox = (): UseLightboxReturn => {
    const embed = React.useContext(EmbedContext)
    const app = React.useContext(AppContext)

    const open = React.useCallback((src: string, attrs: NinchatAttributes.NinchatFileAttributes | null, options?: { downloadDisabled?: boolean }) => {
        const props = {
            lightBox: {
                imageAttr: attrs,
                imageSrc: src,
                open: true,
                options: {downloadDisabled: options?.downloadDisabled ?? false},
            },
        }

        if (embed) {
            embed?.setEmbedState((prevState) => ({
                ...prevState,
                ...props,
            }))
        } else {
            app?.setAppState((prevState) => ({
                ...prevState,
                ...props,
            }))
        }
    }, [embed, app])

    const close = React.useCallback(() => {
        const props = {
            lightBox: {
                imageAttr: null,
                imageSrc: null,
                open: false,
                options: {downloadDisabled: false},
            },
        }

        if (embed) {
            embed?.setEmbedState((prevState) => ({
                ...prevState,
                ...props,
            }))
        } else {
            app?.setAppState((prevState) => ({
                ...prevState,
                ...props,
            }))
        }
    }, [embed, app])

    const fileAttrs = embed?.embedState.lightBox.imageAttr ?? app?.appState.lightBox.imageAttr ?? null
    const isOpen = embed?.embedState.lightBox.open ?? app?.appState.lightBox.open ?? false
    const options = embed?.embedState.lightBox.options ?? app?.appState.lightBox.options ?? {}
    const src = embed?.embedState.lightBox.imageSrc ?? app?.appState.lightBox.imageSrc ?? null

    return {
        close,
        fileAttrs,
        isOpen,
        open,
        options,
        src,
    }
}

export default useLightbox
